import CommunityCategoryDto from '@/src/models/CommumityCategoryDto';
import CommunityReportDto from '@/src/models/CommunityReportDto';
import { CustomersDto } from '@/src/models/CustomersDto';
import { Media } from '@/src/models/MeidaDto';

export default class CommunityPostingDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  // 블라인드 일자
  blindProcessedAt?: string;
  // 유형
  communityPostingCategoryType: string;
  // 유형(한글)
  communityPostingCategoryTypeKr: string;
  // 신고 상태
  communityReportType: string;
  // 제목
  title: string;
  // 내용
  content: string;
  // 상단 노출 여부
  isPopularPosting: boolean;
  // 작성자
  customer: CustomersDto;
  // 게시글 이미지
  communityMedias: { media: Media }[];
  // 신고 데이터
  communityReport?: CommunityReportDto;

  // 조회 수
  communityViewHistoryCount: number;
  // 댓글수
  communityCommentCount: number;
  // 좋아요수
  communityLikeCount: number;
  // 북마크수
  communityBookmarkCount: number;

  communityCategory: CommunityCategoryDto;

  // 지급 크레딧 정보
  communityActiveHistories: {
    createdAt: string;
    creditActionType: string;
    creditValue: number;
    deletedAt: string;
    id: number;
    updatedAt: string;
  };
}
